<template>
  <div class="incenters">
    <div>
      <Commonbtn backgroundColor="#FFF" :optional="seeOptional"  title="查看" fontSize="14px" @btnclick="see" :src="require('@/assets/icon/look.png')">
      </Commonbtn>
      <Commonbtn v-if="qx.reset" backgroundColor="#FFF" opwidth="71px" top="271px" :optional="ResetOptional"  title="重置" fontSize="14px" @btnclick="Reset" :src="require('@/assets/icon/shua.png')">
      </Commonbtn>
      <Commonbtn v-if="qx.skip" backgroundColor="#FFF" opwidth="71px" top="271px" :optional="skipOptional"  title="跳过" fontSize="14px" @btnclick="skip" :src="require('@/assets/icon/tiao.png')">
      </Commonbtn>
    </div>
    <!-- style="border: 1px solid blue;" -->
    <div class="TableWidth">
      <Commontable @onRowClick="onRowClick" colnum=7 :tableData="tableData" :headerData="headerData" height="100%">
      </Commontable>
      <div class="pagination">
        <Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total"></Pagination>
      </div>
    </div>
    <DialogFrom width="680px" title="查看" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK">
      <div class="from" style="height: 400px;overflow:scroll;">
        <json-viewer :value="DetailsList" :expand-depth=5 copyable boxed sort></json-viewer>
      </div>
    </DialogFrom>
    <DialogFrom width="680px" title="跳过原因" :dialogVisible="dialogVisiblesskip" @cancel="cancelskip" @dialogOK="dialogOKskip">
      <div style="font-size: 14px;color: #000;margin-left: 10px;">
        请填写跳过原因
      </div>
      <!-- style="height: 300px;overflow:scroll;" -->
      <div class="from">
        <textarea style="margin-left: 10px;border: 1px solid #E6E6E6;border-radius: 2px; width: 620px; height: 260px;" type="textarea" placeholder="请输入内容" v-model="skipData" />
      </div>
    </DialogFrom>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel" :src="require('@/assets/icon/icon-del2.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除该菜单吗？</span>
    </Dialog>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleReset" @cancel="cancelReset" @dialogOK="dialogOKReset" :src="require('@/assets/icon/icon-errors.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置该条数据吗？</span>
    </Dialog>
  </div>
</template>
<script>
import Commondropdownlist from '../../../../../components/common-dropdownlist.vue'
import Commontable from '../../../../../components/common-table.vue'
import Commonbtn from '../../../../../components/common-btn.vue'
import Pagination from '../../../../../components/pagination.vue'
import DialogFrom from '../../../../../components/dialog-from.vue'
import fromdata from '../fromData/add'
import fromdataedit from '../fromData/edit'
import headerData from '../fromData/tabelData/headerData'
import Dialog from '../../../../../components/dialog.vue'
import {
  U8SynchronousEdit,
  U8SynchronousdoReset,
  U8SynchronousDoSkip
} from '@/api/home'
export default {
  components: {
    Commontable,
    Commonbtn,
    Pagination,
    DialogFrom,
    Commondropdownlist,
    Dialog
  },
  props: {
    tableData: {
      type: Array,
      default: Array
    },
    total: {
      type: Number,
      default: 0
    },
  },
  data: function () {
    return {
      dialogVisibles: false,
      dialogVisiblesedit: false,
      dialogVisibledel: false,
      dialogVisibleReset: false,
      dialogVisiblesskip: false,
      rowboo: false,
      dwonleft: false,
      seeOptional: false,
      ResetOptional: true,
      skipOptional: true,
      ptype: '',
      skipData: '',
      id: null,
      fromdataadd: [],
      fromdataedit: [],
      qus: [],
      DetailsList: [],
      qx: {
        add: false,
        update: false,
        del: false,
        stopif: true,
        daoc: true,
        assignment: false,
        enabled: false,
        submit: false,
        skip: false,//跳过
        reset: false, //重置
      },
      headerData: [],
    }
  },
  mounted() {
    this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
    this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
    this.headerData = JSON.parse(JSON.stringify(headerData))
    this.QX()
  },
  methods: {
    QX() {
      let data = JSON.parse(localStorage.getItem("MenusData"))
      let NodeID = this.$route.query.NodeID
       data.Menus.map((item,index)=>{
        if(item.NodeID == 31){
            item.Nodes.map((items,indexs)=>{
              if(items.NodeID == 32){
                   this.qus = items.Nodes
              }
            })
        }
      })
      if (this.qus) {
        this.qus.map((item, index) => {
          if (item.NodeName == 'add') {
            this.qx.add = true
          } else if (item.NodeName == 'edit') {
            this.qx.update = true
          } else if (item.NodeName == 'delete') {
            this.qx.del = true
          } else if (item.NodeName == 'stopif') {
            this.qx.del = true
          } else if (item.NodeName == 'assignment') {
            this.qx.assignment = true
          } else if (item.NodeName == 'enabled') {
            this.qx.enabled = true
          } else if (item.NodeName == 'skip') {
            this.qx.skip = true
          } else if (item.NodeName == 'reset') {
            this.qx.reset = true
          }
        })
      }
      //console.log("qux", this.qus)
    },
    // 查看
    async u8SynchronousEdit() {
      const loading = this.$loading({
        lock: true,
        text: '正在加载列表...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });

      let {
        code,
        data
      } = await U8SynchronousEdit({
        ID: this.id
      })
      if (code == 0) {
        this.DetailsList = JSON.parse(data.data.DetailsList)
        this.dialogVisibles = true
        this.rowboo = false
        loading.close();
      }
      loading.close();
    },
    // 重置
    async u8SynchronousdoReset() {
      let {
        code,
        data
      } = await U8SynchronousdoReset({
        ID: this.id
      })
      if (code == 0) {
        this.$message({
          type: 'success',
          message: '重置成功'
        })
        this.rowboo = false
        this.$parent.u8SynchronousList()
      }
    },
    // 跳过
    async u8SynchronousDoSkip() {
      let {
        code,
        data
      } = await U8SynchronousDoSkip({
        ID: this.id,
        SkipReason: this.skipData
      })
      if (code == 0) {
        this.$message({
          type: 'success',
          message: '跳过成功'
        })
        this.rowboo = false
        this.$parent.u8SynchronousList()
      }
    },
    onRowClick(val) {
      //console.log(val, 'dtval');
      this.id = val.ID
      if(val.Status == 1){
        this.skipOptional = true
        this.ResetOptional = true
      }
      if(val.Status == 0 || val.Status == 2){
        this.skipOptional = false
        this.ResetOptional = true
      }
      if(val.Status == 3 || val.Status == 2 || val.Status == 4){
        this.ResetOptional = false
        this.skipOptional = true
      }
      this.rowboo = true
    },
    Reset() {
      if (this.rowboo == true) {
        this.dialogVisibleReset = true
        return
      }
      this.$message({
        type: 'error',
        message: '请先选中要重置的数据'
      })
    },
    skip() {
      if (this.rowboo == true) {
        this.dialogVisiblesskip = true
        return
      }
      this.$message({
        type: 'error',
        message: '请先选中要跳过的数据'
      })
    },
    see() {
      if (this.rowboo == true) {
        this.u8SynchronousEdit()
        return
      }
      this.$message({
        type: 'error',
        message: '请先选中要查看的数据'
      })
    },
    chonguser() {

    },
    cancelskip() {
      this.dialogVisiblesskip = false
    },
    dialogOKskip() {
      this.u8SynchronousDoSkip()
      this.dialogVisiblesskip = false
    },
    cancel() {
      this.dialogVisibles = false
    },
    dialogOK() {
      this.dialogVisibles = false
    },
    update() {
      this.dialogVisiblesedit = true
    },
    canceledit() {
      this.dialogVisiblesedit = false
    },
    dialogOKedit() {
      this.dialogVisiblesedit = false
    },
    del() {
      this.dialogVisibledel = true
    },
    canceldel() {
      this.dialogVisibledel = false
    },
    dialogOKdel() {
      this.dialogVisibledel = false
    },
    cancelReset() {
      this.dialogVisibleReset = false
    },
    dialogOKReset() {
      this.u8SynchronousdoReset()
      this.dialogVisibleReset = false
    },
    handleCurrentChange(pageindex) {
      this.$emit('handleCurrentChange', pageindex)
    },
    handleSizeChange(paegSzie) {
      this.$emit('handleSizeChange', paegSzie)
    },
  }
}
</script>

<style lang="less" scoped>
.incenters {
  height: 100%;

  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  // div {
  //   margin-left: 8px;
  //   margin-right: 8px;
  //   margin-top: 5px;
  //   margin-bottom: 5px;

  // }
  .from {
    width: 100%;
  }

  .signingroles {
    height: 500px;
    width: 100%;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // border: 1px solid red;

    .left {
      height: 240px;
      width: 470px;
      border: 1px solid #e6e6e6;
    }

    .right {
      height: 240px;
      width: 470px;
      border: 1px solid #e6e6e6;
      // pointer-events: none;
    }
  }
}

.right-s {
  position: absolute;
  z-index: 99;
  opacity: 0.5;
  right: 21px;
  width: 470px;
  height: 240px;
  background-color: #ffffff;
  cursor: no-drop;
}

.dwonleft {
  width: 170px;
  height: 48px;
  position: absolute;
  background-color: #ffffff;
  z-index: 99;
  right: 350px;
  top: 322px;
  text-align: center;
  line-height: 48px;
  color: #333333;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  font-size: 14px;
  cursor: pointer;
}

.dwonleft:hover {
  background-color: #f0f0f0;
}
</style>
